import { createContext, useContext } from "react";
import type { ICalendarContext } from "./types";

export const CalendarContext = createContext<ICalendarContext | undefined>(
  undefined,
);

export const useCalendarContext = (): ICalendarContext => {
  const context = useContext(CalendarContext);
  if (!context) {
    throw new Error("useCalendarContext must be used within a Calendar");
  }
  return context;
};
